import { useEffect, useRef } from 'react'

export function useOtpAutoSubmit({
  code,
  length,
  isSubmitting,
  hasError,
  onSubmit,
}: {
  code: string
  length: number
  isSubmitting: boolean
  hasError: boolean
  onSubmit: () => void
}) {
  // A rejected or already-submitting code must not restart on mount or failure.
  const lastSubmitted = useRef<string | undefined>(
    hasError || isSubmitting ? code : undefined,
  )
  useEffect(() => {
    if (code.length === 0 || code.length !== length) {
      lastSubmitted.current = undefined
      return
    }
    if (isSubmitting) {
      lastSubmitted.current = code
      return
    }
    if (lastSubmitted.current === code) {
      return
    }
    lastSubmitted.current = code
    onSubmit()
  }, [code, length, isSubmitting, onSubmit])
}
